import { render, staticRenderFns } from "./setting-dangerZone.vue?vue&type=template&id=2c0097ce&scoped=true&"
import script from "./setting-dangerZone.vue?vue&type=script&lang=js&"
export * from "./setting-dangerZone.vue?vue&type=script&lang=js&"
import style0 from "./setting-dangerZone.vue?vue&type=style&index=0&id=2c0097ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0097ce",
  null
  
)

export default component.exports